const eeccCategoriesMapper = {
  EX: { text: 'Extinto', backgroundColor: 'black', textColor: 'white' },
  EW: { text: 'Extinta en estado silvestre', backgroundColor: '#742c84', textColor: 'white' },
  CR: { text: 'En peligro crítico', backgroundColor: '#e62118', textColor: 'white' },
  EN: { text: 'En peligro', backgroundColor: '#f0602e', textColor: 'white' },
  'EN-R': { text: 'En peligro con rango restringido', backgroundColor: '#f4913e', textColor: 'white' },
  VU: { text: 'Vulnerable', backgroundColor: '#f9b233', textColor: 'white' },
  NT: { text: 'Casi amenazada', backgroundColor: '#3aaa35', textColor: 'white' },
  LC: { text: 'Preocupación menor', backgroundColor: '#12a19a', textColor: 'white' },
  DD: { text: 'Datos insuficientes', backgroundColor: '#b3b2b2', textColor: 'black' },
  ND: { text: 'No determinado', backgroundColor: '#b3b2b2', textColor: 'white' },
  R: { text: 'Rara', backgroundColor: '#A9CD8A', textColor: 'black' },
};


export { eeccCategoriesMapper };
